import React from "react";

import { useProgressBarContext } from "@src/features/personalizations/components/offerModifications/userInterfaces/progressBar/ProgressBarContext";
import { CartValueNumberInput } from "@src/features/personalizations/components/offerModifications/widgets/CartValueNumberInput";
import { CartValueToggle } from "@src/features/personalizations/components/offerModifications/widgets/CartValueToggle";

interface CartValueInputProps {
  size: "medium" | "small";
}

export const CartValueInput = ({ size }: CartValueInputProps) => {
  const { mode } = useProgressBarContext();
  if (mode === "input") {
    return <CartValueNumberInput />;
  } else {
    return <CartValueToggle />;
  }
};
